import { FC } from 'react';
import { CheckboxField, useControlledField } from '@frontend/design-system';
import { checkboxContainerStyle } from './checklist-field.styles';

interface InlineChecklistFieldProps {
  options: Array<{ label: string; value: string }>;
  fieldId: string;
  value: string[];
  onChange: (value: string[]) => void;
  onBlur: () => void;
}

const InlineCheckboxOption: FC<{
  option: { label: string; value: string };
  fieldId: string;
  isChecked: boolean;
  onToggle: (optionValue: string, checked: boolean) => void;
}> = ({ option, fieldId, isChecked, onToggle }) => {
  const checkboxProps = useControlledField({
    type: 'checkbox',
    value: isChecked,
    onChange: (checked: boolean) => onToggle(option.value, checked),
  });

  return <CheckboxField {...checkboxProps} name={`${fieldId}-opt-${option.value}`} label={option.label} />;
};

export const InlineChecklistField: FC<InlineChecklistFieldProps> = ({ options, fieldId, value, onChange, onBlur }) => {
  const handleToggle = (optionValue: string, checked: boolean) => {
    const newValue = checked ? [...(value || []), optionValue] : (value || []).filter((v) => v !== optionValue);
    onChange(newValue);
    onBlur();
  };

  return (
    <div css={checkboxContainerStyle}>
      {options.map((option) => {
        if (!option || !option.value) {
          return null;
        }

        const isChecked = (value || []).includes(option.value);

        return (
          <InlineCheckboxOption
            key={`${fieldId}-opt-${option.value}`}
            option={option}
            fieldId={fieldId}
            isChecked={isChecked}
            onToggle={handleToggle}
          />
        );
      })}
    </div>
  );
};
